import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";


type NewLead = {
  mobile_number?: string;
  alternate_mobile?: string;
  student_name?: string;
  parent_name?: string;
  dob?: string;
  gender?: number;
  email?: string;
  state?: string;
  district?: string;
  address?: string;
  city?: string;
  current_school?: string;
  current_class?: string;
  enrolling_class?: string;
  source?: number;
  status?: number;
};

const EditPrismLead = () => {
  const routes = all_routes;
  const location = useLocation();
  const { id } = location.state || {};
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [newLead, setNewLead] = useState<NewLead>({});
  const [souresDropdown, setSourcesDropdown] = useState<{ id: number; name: string }[]>([]);
  const [statusDropdown, setStatusDropdown] = useState<{ id: number; name: string }[]>([]);
  const [genderDropdown, setGenderDropdown] = useState<{ gender_id: number; name: string }[]>([]);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  const [errors, setErrors] = useState<Partial<Record<keyof NewLead, string>>>({});
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   try {
  //     const [dispositionsData, typeOfTicketData] = await Promise.all([
  //       fetchDispositions(),
  //       fetchTypeOfTicket(),
  //     ]);
  //     setDispositions(dispositionsData);
  //     setTypeOfTicket(typeOfTicketData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!checkPermission("change_schoollead", "schoollead")) {
      navigate(routes.adminDashboard);
    } else {
      fetchSourcesData();
      fetchStatusData();
      fetchGenderData();
      fetchLeadData();
    }
  }, [userPermissions]);




  const fetchLeadData = async () => {
    const response = await fetch(`${webApi}/school_leads/create_school_lead/${id}/`, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch sources data");
    }
    const data = await response.json();
    setNewLead(data);
  };


  const fetchSourcesData = async () => {
    const response = await fetch(`${webApi}/school_leads/lead_source_dropdown/`, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch sources data");
    }
    const data = await response.json();
    setSourcesDropdown(data);
  };

  const fetchStatusData = async () => {
    const response = await fetch(`${webApi}/school_leads/lead_status_dropdown/`, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch sources data");
    }
    const data = await response.json();
    setStatusDropdown(data);
  };

  const fetchGenderData = async () => {
    const response = await fetch(`${webApi}/students/students_gender_dropdown/`, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch sources data");
    }
    const data = await response.json();
    setGenderDropdown(data.results);
  };


  const updateData = async (): Promise<boolean> => {
    try {
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(newLead),
      };

      const url = `${webApi}/school_leads/create_school_lead/${id}/`;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        const errorData = await response.json();

        const formattedErrors: Partial<Record<keyof NewLead, string>> = {};

        Object.keys(errorData).forEach((key) => {
          formattedErrors[key as keyof NewLead] = Array.isArray(errorData[key])
            ? errorData[key][0]
            : errorData[key];
        });

        setErrors(formattedErrors);
        return false; // ❌ failure
      }

      setErrors({});
      return true; // ✅ success
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const success = await updateData();

      if (success) {
        navigate(routes.prismPendingLeads);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewLead({ ...newLead, [name]: value || null });
  };

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const updateLead = (field: keyof NewLead, value: any) => {
    setNewLead((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit LEad</h3>
                <ul className="breadcrumb">
                  {/* <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li> */}
                  <li className="breadcrumb-item">
                    <Link to={routes.prismPendingLeads}>List</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Lead</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit} className="d-flex flex-column">
                    <div className="modal-body light-violet-bg">
                      <div className="row">

                        {/* Mobile */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Mobile Number</label>
                          <input
                            type="text"
                            className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                            value={newLead.mobile_number || ""}
                            onChange={(e) => updateLead("mobile_number", e.target.value)}
                          />
                          {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
                        </div>

                        {/* Alternate Mobile */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Alternate Mobile</label>
                          <input
                            type="text"
                            className={`form-control ${errors.alternate_mobile ? "is-invalid" : ""}`}
                            value={newLead.alternate_mobile || ""}
                            onChange={(e) => updateLead("alternate_mobile", e.target.value)}
                          />
                          {errors.alternate_mobile && <div className="invalid-feedback">{errors.alternate_mobile}</div>}
                        </div>

                        {/* Student Name */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Student Name</label>
                          <input
                            type="text"
                            className={`form-control ${errors.student_name ? "is-invalid" : ""}`}
                            value={newLead.student_name || ""}
                            onChange={(e) => updateLead("student_name", e.target.value)}
                          />
                          {errors.student_name && <div className="invalid-feedback">{errors.student_name}</div>}
                        </div>

                        {/* Parent Name */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Parent Name</label>
                          <input
                            type="text"
                            className={`form-control ${errors.parent_name ? "is-invalid" : ""}`}
                            value={newLead.parent_name || ""}
                            onChange={(e) => updateLead("parent_name", e.target.value)}
                          />
                          {errors.parent_name && <div className="invalid-feedback">{errors.parent_name}</div>}
                        </div>

                        {/* DOB */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Date of Birth</label>
                          <input
                            type="date"
                            className={`form-control ${errors.dob ? "is-invalid" : ""}`}
                            value={newLead.dob || ""}
                            onChange={(e) => updateLead("dob", e.target.value)}
                          />
                          {errors.dob && <div className="invalid-feedback">{errors.dob}</div>}
                        </div>

                        {/* Gender */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Gender</label>
                          <select
                            className={`form-control ${errors.gender ? "is-invalid" : ""}`}
                            value={newLead.gender ?? ""}
                            onChange={(e) => updateLead("gender", Number(e.target.value))}
                          >
                            <option value="">Select Gender</option>
                            {genderDropdown.map((g) => (
                              <option key={g.gender_id} value={g.gender_id}>
                                {g.name}
                              </option>
                            ))}
                          </select>
                          {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
                        </div>

                        {/* Email */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            value={newLead.email || ""}
                            onChange={(e) => updateLead("email", e.target.value)}
                          />
                          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>

                        {/* State */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">State</label>
                          <input
                            type="text"
                            className={`form-control ${errors.state ? "is-invalid" : ""}`}
                            value={newLead.state || ""}
                            onChange={(e) => updateLead("state", e.target.value)}
                          />
                          {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                        </div>

                        {/* District */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">District</label>
                          <input
                            type="text"
                            className={`form-control ${errors.district ? "is-invalid" : ""}`}
                            value={newLead.district || ""}
                            onChange={(e) => updateLead("district", e.target.value)}
                          />
                          {errors.district && <div className="invalid-feedback">{errors.district}</div>}
                        </div>

                        {/* City */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">City</label>
                          <input
                            type="text"
                            className={`form-control ${errors.city ? "is-invalid" : ""}`}
                            value={newLead.city || ""}
                            onChange={(e) => updateLead("city", e.target.value)}
                          />
                          {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                        </div>

                        {/* Address */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Address</label>
                          <input
                            type="text"
                            className={`form-control ${errors.address ? "is-invalid" : ""}`}
                            value={newLead.address || ""}
                            onChange={(e) => updateLead("address", e.target.value)}
                          />
                          {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                        </div>

                        {/* Current School */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Current School</label>
                          <input
                            type="text"
                            className={`form-control ${errors.current_school ? "is-invalid" : ""}`}
                            value={newLead.current_school || ""}
                            onChange={(e) => updateLead("current_school", e.target.value)}
                          />
                          {errors.current_school && <div className="invalid-feedback">{errors.current_school}</div>}
                        </div>

                        {/* Current Class */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Current Class</label>
                          <input
                            type="text"
                            className={`form-control ${errors.current_class ? "is-invalid" : ""}`}
                            value={newLead.current_class || ""}
                            onChange={(e) => updateLead("current_class", e.target.value)}
                          />
                          {errors.current_class && <div className="invalid-feedback">{errors.current_class}</div>}
                        </div>

                        {/* Enrolling Class */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Enrolling Class</label>
                          <input
                            type="text"
                            className={`form-control ${errors.enrolling_class ? "is-invalid" : ""}`}
                            value={newLead.enrolling_class || ""}
                            onChange={(e) => updateLead("enrolling_class", e.target.value)}
                          />
                          {errors.enrolling_class && <div className="invalid-feedback">{errors.enrolling_class}</div>}
                        </div>

                        {/* Source */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Source</label>
                          <select
                            className={`form-control ${errors.source ? "is-invalid" : ""}`}
                            value={newLead.source ?? ""}
                            onChange={(e) => updateLead("source", Number(e.target.value))}
                          >
                            <option value="">Select Source</option>
                            {souresDropdown.map((s) => (
                              <option key={s.id} value={s.id}>
                                {s.name}
                              </option>
                            ))}
                          </select>
                          {errors.source && <div className="invalid-feedback">{errors.source}</div>}
                        </div>

                        {/* Status */}
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label className="form-label">Status</label>
                          <select
                            className={`form-control ${errors.status ? "is-invalid" : ""}`}
                            value={newLead.status ?? ""}
                            onChange={(e) => updateLead("status", Number(e.target.value))}
                          >
                            <option value="">Select Status</option>
                            {statusDropdown.map((s) => (
                              <option key={s.id} value={s.id}>
                                {s.name}
                              </option>
                            ))}
                          </select>
                          {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                        </div>

                      </div>
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.prismPendingLeads}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPrismLead;
